/* io-cart.js - Dynamic Shipping Bar + Empty State + Visibility Manager
   REV 2: adds live "(n items)" title count + scroll-affordance controller */

document.addEventListener('DOMContentLoaded', function () {

  /* =============================================================
     1. DYNAMIC STATE MANAGER
     ============================================================= */

  /* NOTE: this value is in CENTS. item.final_line_price is in cents too,
     so 100 === $1.00 — which is why the bar reads "FREE SHIPPING unlocked"
     on virtually every cart. If the real threshold is $100, set this to
     10000 and update `free_shipping_threshold` in cart-drawer.liquid to match. */
  const FREE_SHIPPING_THRESHOLD = 100; // in cents
  let latestCartCache = null;

  // We only show the empty state if we've confirmed it via a fresh /cart.js call
  let cartConfirmedEmpty = false;

  // --- A. TOGGLE VIEW FUNCTION ---
  function toggleDrawerState(cart) {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || !cart) return;

    // Never force "empty" unless confirmed from a real fetch
    if (cart.item_count === 0 && !cartConfirmedEmpty) {
      cartDrawer.classList.remove('drawer--is-empty');
      cartDrawer.classList.add('drawer--has-items');
      return;
    }

    if (cart.item_count > 0) {
      cartDrawer.classList.remove('drawer--is-empty');
      cartDrawer.classList.add('drawer--has-items');
    } else {
      cartDrawer.classList.remove('drawer--has-items');
      cartDrawer.classList.add('drawer--is-empty');
    }
  }

  // --- B. SHIPPING BAR UPDATE (Excludes Gift Cards) ---
  function updateShippingBar(cart) {
    const barFill = document.querySelector('.io-bar-fill');
    const barText = document.querySelector('.io-bar-text');

    if (!barFill || !barText) return;

    // 1. Calculate Eligible Total (Skipping Gift Cards)
    let eligibleTotal = 0;

    if (cart.items) {
      cart.items.forEach(item => {
        const typeStr = (item.product_type || "").toLowerCase();
        const titleStr = (item.title || "").toLowerCase();

        // identifying gift cards by type or title
        const isGiftCard = typeStr.includes('gift card') || titleStr.includes('gift card');

        if (!isGiftCard) {
          eligibleTotal += item.final_line_price;
        }
      });
    }

    // 2. Calculate Progress
    const percent = Math.min((eligibleTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
    const remainingCents = FREE_SHIPPING_THRESHOLD - eligibleTotal;
    const remainingDollars = (remainingCents / 100).toFixed(2);

    // 3. Update UI
    let newText = "";
    if (eligibleTotal >= FREE_SHIPPING_THRESHOLD) {
      newText = "You've unlocked <strong>FREE SHIPPING!</strong>";
    } else {
      newText = `Add <strong>$${remainingDollars}</strong> to unlock Free Shipping!`;
    }

    if (barFill.style.width !== `${percent}%`) barFill.style.width = `${percent}%`;
    if (barText.innerHTML.trim() !== newText.trim()) barText.innerHTML = newText;
  }

  function updateHeaderBubble(cart) {
    const bubble = document.getElementById('CartCount') || document.querySelector('.cart-link__bubble');
    if (bubble) {
      let realCount = cart.item_count;
      const currentText = bubble.textContent.trim();
      const newText = realCount.toString();

      if (realCount > 0) {
         if (currentText !== newText) bubble.textContent = newText;
         bubble.classList.add('cart-link__bubble--visible');
         bubble.style.display = 'flex';
      } else {
         bubble.classList.remove('cart-link__bubble--visible');
         bubble.style.display = 'none';
      }
    }
  }

  /* -------------------------------------------------------------
     DISCOUNT ROW — driven by cart data, not by whatever the theme
     happens to have left in the DOM.

     :empty in CSS isn't enough: the Liquid block leaves whitespace, and
     the theme can leave a stale row behind after a code is removed. This
     is the single source of truth — no cart-level discount, no row.
     ------------------------------------------------------------- */
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function centsToMoney(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function updateDiscounts(cart) {
    const wrap = document.querySelector('#CartDrawer [data-discounts]');
    if (!wrap) return;

    const applications = (cart && cart.cart_level_discount_applications) || [];

    if (!applications.length) {
      wrap.classList.add('io-hidden');
      return;
    }

    wrap.classList.remove('io-hidden');

    // Leave the theme's own markup alone when it already matches the cart
    // (it knows your currency formatting). Re-render if it's empty, has the
    // wrong number of rows, or is showing a code that's no longer applied.
    const renderedRows = wrap.querySelectorAll('.cart__discount').length;
    const titlesMatch = applications.every(function (d) {
      return wrap.textContent.indexOf(d.title) !== -1;
    });

    if (!wrap.textContent.trim() || renderedRows !== applications.length || !titlesMatch) {
      const rows = applications.map(function (d) {
        // Automatic discounts can come through without a title
        const label = d.title || d.description || 'Discount';
        return '<div class="cart__discount">' +
          escapeHtml(label) + ' (-' + centsToMoney(d.total_allocated_amount) + ')' +
          '</div>';
      }).join('');

      wrap.innerHTML =
        '<div class="cart__discounts cart__item-sub cart__item-row">' +
          '<div>Discounts</div>' +
          '<div class="text-right">' + rows + '</div>' +
        '</div>';
    }
  }

  /* -------------------------------------------------------------
     "YOUR BAG (4 items)" title counter
     ------------------------------------------------------------- */
  function updateTitleCount(cart) {
    const labels = document.querySelectorAll('[data-cart-count-label]');
    if (!labels.length) return;

    const count = (cart && cart.item_count) || 0;
    const text = count > 0 ? `(${count} ${count === 1 ? 'item' : 'items'})` : '';

    labels.forEach(el => {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  /* =============================================================
     1.5. SCROLL AFFORDANCE CONTROLLER
     Adds .can-scroll-up / .can-scroll-down to .drawer__scroll-viewport
     so the CSS fades and the "MORE" chevron know when to show.

     The theme rebuilds [data-products] from scratch on every cart change,
     so for ~300ms the list height is meaningless. Three guards keep the
     cue from flashing during that window:
       1. SETTLE  - .io-settling hides the cue while the DOM is churning
       2. HYSTERESIS - it takes more overflow to turn the cue ON than OFF
       3. CONSTANT PADDING (in CSS) - so toggling the class can't change
          scrollHeight and feed back into the overflow test
     ============================================================= */

  const CUE_ON_PX  = 14;  // needs this much hidden content before the cue appears
  const CUE_OFF_PX = 4;   // ...but only drops off below this, so it can't chatter
  const SETTLE_MS  = 380; // quiet period after the last DOM change
  const MAX_SETTLE_MS = 1200; // never suppress the cue longer than this
  const RESIZE_MS  = 260; // parchment grow/shrink animation

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const settleTimers = new WeakMap();
  const resizeTimers = new WeakMap();

  function measureViewport(viewport) {
    const area = viewport.querySelector('.drawer__scrollable');
    if (!area) return;

    // Hold the current classes steady while the list is being rebuilt.
    if (viewport.classList.contains('io-settling')) return;

    const overflow = area.scrollHeight - area.clientHeight;
    const alreadyOn = viewport.classList.contains('has-overflow');
    const canScroll = overflow > (alreadyOn ? CUE_OFF_PX : CUE_ON_PX);

    viewport.classList.toggle('has-overflow', canScroll);
    viewport.classList.toggle('can-scroll-up', canScroll && area.scrollTop > CUE_OFF_PX);
    viewport.classList.toggle('can-scroll-down', canScroll && area.scrollTop < overflow - CUE_OFF_PX);
  }

  function refreshScrollCues() {
    document.querySelectorAll('.drawer__scroll-viewport').forEach(measureViewport);
  }

  function scheduleScrollCueRefresh() {
    requestAnimationFrame(refreshScrollCues);
  }

  /* Animate the parchment between its old and new natural height so an
     add/remove reads as a grow, not a snap. Inline height is always
     cleared afterwards (and by a safety timer) so the flex layout stays
     in charge. */
  function animateViewportHeight(viewport) {
    if (prefersReducedMotion) return;

    try {
      const from = viewport.offsetHeight;

      viewport.style.transition = 'none';
      viewport.style.height = '';           // let it settle to its natural size
      const to = viewport.offsetHeight;

      if (!from || Math.abs(to - from) < 3) {
        viewport.style.transition = '';
        return;
      }

      viewport.style.height = from + 'px';
      void viewport.offsetHeight;            // force reflow so the next line animates
      viewport.style.transition = 'height ' + RESIZE_MS + 'ms ease';
      viewport.style.height = to + 'px';
    } catch (err) {
      viewport.style.transition = '';
      viewport.style.height = '';
      return;
    }

    clearTimeout(resizeTimers.get(viewport));
    resizeTimers.set(viewport, setTimeout(function () {
      viewport.style.transition = '';
      viewport.style.height = '';
      measureViewport(viewport);
    }, RESIZE_MS + 60));
  }

  /* Called whenever the list content changes. Hides the cue, waits for the
     churn to stop, then resizes and re-measures once. */
  function markSettling(viewport) {
    const now = Date.now();
    const startedAt = Number(viewport.dataset.ioSettleStart || 0);

    // Hard cap: if something on the page mutates the drawer continuously
    // (an app widget, a lazy-loader), never suppress the cue for longer
    // than MAX_SETTLE_MS total — otherwise it could hide forever.
    if (viewport.classList.contains('io-settling') && startedAt && now - startedAt > MAX_SETTLE_MS) {
      return;
    }
    if (!viewport.classList.contains('io-settling')) {
      viewport.dataset.ioSettleStart = String(now);
    }

    viewport.classList.add('io-settling');

    clearTimeout(settleTimers.get(viewport));
    settleTimers.set(viewport, setTimeout(function () {
      viewport.classList.remove('io-settling');
      delete viewport.dataset.ioSettleStart;
      animateViewportHeight(viewport);
      measureViewport(viewport);
    }, SETTLE_MS));
  }

  function settleAllViewports() {
    document.querySelectorAll('.drawer__scroll-viewport').forEach(markSettling);
  }

  /* PRODUCT IMAGE FLASH
     The theme rebuilds the line items from scratch on every cart change,
     so the browser gets brand-new <img> nodes each time. Two things then
     make them blink even though the file is already in cache:

       loading="lazy"    - the fetch is deferred until the intersection
                           observer runs, which is at least one frame away
       decoding="async"  - the default; the image paints on a later frame
                           than the row it belongs to

     No CSS can fix that — there is nothing to fade, the pixels just are
     not there yet. Flipping both to eager/sync makes the browser paint
     the cached image in the same frame as the row.

     This has to run BEFORE paint, which is why it is called from inside
     the MutationObserver callback (microtask checkpoint) rather than on
     a timer. Each image is only touched once. */
  function pinImages(area) {
    if (!area) return;
    const images = area.querySelectorAll('img:not([data-io-img])');
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      img.setAttribute('data-io-img', '1');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'sync');
      if ('fetchPriority' in img) img.fetchPriority = 'high';
    }
  }

  function initScrollCues() {
    document.querySelectorAll('.drawer__scroll-viewport').forEach(viewport => {
      if (viewport.dataset.ioScrollBound === '1') return;
      viewport.dataset.ioScrollBound = '1';

      const area = viewport.querySelector('.drawer__scrollable');
      const cue = viewport.querySelector('[data-scroll-cue]');
      if (!area) return;

      area.addEventListener('scroll', function () { measureViewport(viewport); }, { passive: true });

      // Clicking / tapping the chevron pages down through the list
      if (cue) {
        cue.addEventListener('click', function (e) {
          e.preventDefault();
          area.scrollBy({ top: Math.round(area.clientHeight * 0.8), behavior: 'smooth' });
        });
      }

      // The theme replacing the line items = start of a settle window
      const listObserver = new MutationObserver(function () {
        pinImages(area);          // synchronous: runs before the next paint
        markSettling(viewport);
      });
      listObserver.observe(area, { childList: true, subtree: true });

      pinImages(area);


      // Late height changes (images decoding, fonts swapping) — re-measure
      // only. Never restart the settle window from here or slow-loading
      // thumbnails would keep the cue suppressed indefinitely.
      if (typeof ResizeObserver !== 'undefined') {
        let roTimer = null;
        const ro = new ResizeObserver(function () {
          clearTimeout(roTimer);
          roTimer = setTimeout(function () { measureViewport(viewport); }, 60);
        });
        ro.observe(area);
        const products = area.querySelector('[data-products]');
        if (products) ro.observe(products);
      }

      // Suppress the cue for the first moment after binding, so it can't
      // appear over an empty parchment while the drawer is still filling in.
      markSettling(viewport);
    });

  }

  window.addEventListener('resize', scheduleScrollCueRefresh, { passive: true });
  window.addEventListener('orientationchange', scheduleScrollCueRefresh, { passive: true });

  // --- C. MASTER UPDATE FUNCTION ---
  function updateAllCartElements(cart) {
    if (!cart) return;

    latestCartCache = cart;
    cartConfirmedEmpty = (cart.item_count === 0);

    toggleDrawerState(cart);
    updateShippingBar(cart);
    updateHeaderBubble(cart);
    updateTitleCount(cart);
    updateDiscounts(cart);

    initScrollCues();          // idempotent — binds once per viewport
    scheduleScrollCueRefresh();
  }

  async function syncCart() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json());

      updateAllCartElements(cart);
    } catch (err) {
      // If we can't sync, do NOT force empty state.
      if (latestCartCache) {
        toggleDrawerState(latestCartCache);
        updateShippingBar(latestCartCache);
        updateTitleCount(latestCartCache);
      }
      console.warn('[io-cart] cart sync failed', err);
    }
  }

  /* =============================================================
     2. EVENT LISTENERS
     ============================================================= */

  /* =============================================================
     2.5. BFCACHE / BACK BUTTON RESYNC
     ============================================================= */

  // Fires when returning via Back/Forward (including bfcache restores)
  window.addEventListener('pageshow', function (event) {
    syncCart();
  });

  // Optional: also resync when tab becomes visible again (helps iOS Safari edge cases)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      syncCart();
    }
  });

  // Theme-standard event
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateAllCartElements(evt.detail.cart);
    } else {
      syncCart();
    }
  });

  // Drawer open/close scroll lock
  document.addEventListener('drawer:open', function () {
    document.body.classList.add('no-scroll');
    // Force a sync when drawer opens to ensure bar is up to date
    syncCart();
    // Keep the cue hidden until the list has actually painted
    settleAllViewports();
  });

  document.addEventListener('drawer:close', function () {
    document.body.classList.remove('no-scroll');
  });

  // Basic add-to-cart safety sync
  document.body.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.includes('/cart/add')) {
      // We removed stopImmediatePropagation to allow the theme to handle the open event
      settleAllViewports(); // start the quiet window BEFORE the theme re-renders
      setTimeout(syncCart, 400);
      setTimeout(syncCart, 1200);
    }
  });

  // MutationObserver: when drawer HTML changes, re-sync the real cart
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    let drawerSyncTimer = null;

    // childList/subtree only — our cue classes are attribute changes,
    // so toggling them can never re-trigger this observer.
    const observer = new MutationObserver(function () {
      /* SYNCHRONOUS re-bind. When the theme re-renders the drawer it
         replaces .drawer__scroll-viewport with a fresh node, and the
         per-viewport observers bound to the old one are gone. Waiting for
         the debounced syncCart below meant a 150ms gap plus a network
         round trip before anything re-bound — long enough for the app to
         inject and the browser to paint the widget inside the parchment.
         That was the "sometimes it doesn't work". Running here, at the
         microtask checkpoint, closes the gap entirely. */
      initScrollCues();

      if (drawerSyncTimer) clearTimeout(drawerSyncTimer);
      drawerSyncTimer = setTimeout(function () {
        syncCart();
        initScrollCues();
      }, 150);
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  /* =============================================================
     3. INITIAL LOAD
     ============================================================= */
  initScrollCues();
  syncCart();

});